<template>
  <div class="charts" style="width: 100%; height: 100%"></div>
</template>
<script>
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import defaultsdeep from 'lodash.defaultsdeep'
export default {
  name: 'PieCharts',
  props: {
    data: Array,
    option: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    data() {
      this.createCharts()
    }
  },
  mounted() {
    this.createCharts()
  },
  methods: {
    createCharts() {
      if (!this.Chart) this.Chart = echarts.init(this.$el)
      this.Chart.setOption(
        defaultsdeep(
          {},
          {
            tooltip: {
              trigger: 'item',
              formatter: '{b} : {c}份 ({d}%)',
              confine: true
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['50%', '80%'],
                center: ['50%', '50%'],
                data: this.data,
                label: {
                  normal: {
                    textStyle: {
                      color: '#333',
                      fontSize: 12
                    },
                    formatter: '{b}\n{c}份'
                  }
                },
                labelLine: {
                  normal: {
                    lineStyle: {
                      color: '#00C4AA',
                      width: 2
                    },
                    smooth: 0,
                    length: 5,
                    length2: 10
                  }
                },
                animationEasing: 'elasticOut'
              }
            ]
          },
          this.option
        )
      )
    }
  }
}
</script>
